import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HttpService } from 'tms-lib';
import { MagentoSalesOrders, SagePosting, SalesOrderHeaderWebsite, SalesOrderLineWebsite } from '../../models';
import { TmsWebBaseService } from '../base/tms-web-base.service';

@Injectable({
  providedIn: 'root',
})
export class SalesOrdersMagentoService extends TmsWebBaseService {
  constructor(protected httpService: HttpService) {
    super('SalesOrderMagento', httpService);
  }

  getSalesOrders(): Observable<MagentoSalesOrders> {
    return this.httpService.get<MagentoSalesOrders>(`${this.apiUrl}/GetSalesOrders`);
  }

  getLatestSalesOrders(): Observable<MagentoSalesOrders> {
    return this.httpService.get<MagentoSalesOrders>(`${this.apiUrl}/GetLatestSalesOrders`);
  }

  getSalesOrderLines(id: string): Observable<SalesOrderLineWebsite[]> {
    return this.httpService.get<SalesOrderLineWebsite[]>(`${this.apiUrl}/GetSalesOrderLines?id=${id}`);
  }

  importSalesOrders(
    search: string,
    allStock: boolean,
    needAttention: boolean,
    importOrders: boolean,
  ): Observable<SalesOrderHeaderWebsite[]> {
    return this.httpService.post<SalesOrderHeaderWebsite[]>(`${this.apiUrl}/ImportSalesOrders`, {
      search,
      allStock,
      needAttention,
      importOrders,
    });
  }

  postProformaInvoices(update: boolean): Observable<SagePosting[]> {
    return this.httpService.post<SagePosting[]>(`${this.apiUrl}/PostProformaInvoices`, { update });
  }
}
